import React from "react";
import {
    Grid,
    makeStyles,
    Radio,
    Typography,
    FormControlLabel
} from "@material-ui/core";
import {
    TextValidator,
} from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { red } from "@material-ui/core/colors";
import ValidatedDatePicker from "../../../../compartidos/ValidatedDatePicker";

const useStyles = makeStyles((theme) => ({
    title: {
        color: theme.palette.primary.main,
    },
    baja: {
        color: red,
    },
    switchBase: {
        color: "#bdbdbd",
        "&$checked": {
            transform: "translateX(16px)",
            color: "#4CAF50",
            "& + $track": {
                backgroundColor: "#3E8040",
                opacity: 1,
                border: "none",
            },
        },
    },
    checked: {},
    track: {},
}));


export const FormReclamoExternos = (props) => {

    const { formValues, setearValor, handleInputChange } = props;
    const classes = useStyles();


    const validadoresTelefono =
        formValues?.telefono?.length === 10 || formValues?.celular?.length === 10
            ? ["isNumber", "maxNumber:9999999999", "minNumber:999999999"]
            : ["required", "isNumber", "maxNumber:9999999999", "minNumber:999999999"];

    const errorMessageTelefono =
        formValues?.telefono?.length === 10 || formValues?.celular?.length === 10
            ? ["Solo números", "Verifique su teléfono", "Verifique su telefono"]
            : [
                "El teléfono es requerido",
                "Solo números",
                "Verifique su teléfono",
                "Verifique su teléfono",
            ];

    return (
        <>
        <Grid item xs={12}>
          <Grid container justify="center" alignItems="center">
            <Grid
              item
              xs={12}
              md={12}
              style={{ display: "flex", flexDirection: "column" }}
            >
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              style={{ display: "flex", flexDirection: "column" }}
            >
              <Typography align="left" variant="button" color="secondary">
                <span>
                  USUARIO CARGA:{" "}
                  <span className={classes.title}>
                    {formValues.nombreUsuario}
                  </span>
                </span>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
            <ValidatedDatePicker
              fullWidth
              margin="normal"
              label="Fecha Carga"
              format="dd/MM/yyyy"
              okLabel="Aceptar"
              maxDate={new Date()}
              clearLabel="Limpiar"
              cancelLabel="Cancelar"
              value={formValues.fechaCarga}
              onChange={(date) => {
                setearValor("fechaCarga", date);
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              disabled
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin="normal"
            fullWidth
            label="CUIL / CUIT"
            autoComplete="off"
            name="cuit"
            type="number"
            value={formValues?.cuit}
            validators={["required"]}
            errorMessages={["Este campo es obligatorio"]}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: "bold" } }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin="normal"
            fullWidth
            label="Nombre / Razón Social"
            autoComplete="off"
            name="nombre"
            type="text"
            value={formValues?.nombre}
            validators={["required"]}
            errorMessages={["Este campo es obligatorio"]}
            onChange={handleInputChange}
            InputLabelProps={{ style: { fontWeight: "bold" } }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin="normal"
            fullWidth
            label="Número Teléfono"
            autoComplete="off"
            name="telefono"
            type="number"
            value={formValues?.telefono}
            onChange={handleInputChange}
            validators={validadoresTelefono}
            errorMessages={errorMessageTelefono}
            InputLabelProps={{ style: { fontWeight: "bold" } }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextValidator
            variant="outlined"
            margin="normal"
            fullWidth
            label="Número Celular"
            autoComplete="off"
            name="celular"
            type="number"
            value={formValues?.celular}
            onChange={handleInputChange}
            validators={validadoresTelefono}
            errorMessages={errorMessageTelefono}
            InputLabelProps={{ style: { fontWeight: "bold" } }}
          />
        </Grid>
        <Grid item xs={4}>
        <TextValidator
          variant="outlined"
          margin="normal"
          fullWidth
          label="Correo Electrónico"
          autoComplete="off"
          name="email"
          type="email"
          value={formValues?.email}
          validators={["required"]}
          errorMessages={["Este campo es obligatorio"]}
          onChange={handleInputChange}
          InputLabelProps={{ style: { fontWeight: "bold" } }}
        />
      </Grid>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "center", gap: "2em" }}
        >
          <div>
            <FormControlLabel
              control={
                <Radio
                  checked={formValues.urgente === 0}
                  onChange={() => setearValor("urgente", 0)}
                  value="0"
                  name="radio-button-demo"
                  inputProps={{ 'aria-label': '0' }}
                  style={{ color: 'green' }}
                />
              }
              label="Verde"
            />
  
            <FormControlLabel
              control={
                <Radio
                  checked={formValues.urgente === 2}
                  onChange={() => setearValor("urgente", 2)}
                  value="2"
                  name="radio-button-demo"
                  inputProps={{ 'aria-label': '2' }}
                  style={{ color: '#ffcf33' }}
                />
              }
              label="Amarillo"
            />
            <FormControlLabel
              control={
                <Radio
                  checked={formValues.urgente === 1}
                  onChange={() => setearValor("urgente", 1)}
                  value="1"
                  name="radio-button-demo"
                  inputProps={{ 'aria-label': '1' }}
                  style={{ color: 'red' }}
                />
              }
              label="Rojo"
            />
          </div>
        </Grid>
      </>
    )
}
